import { Component, ElementRef, inject, input } from '@angular/core';

@Component({
  host: {
    '[attr.data-ideals]': 'dataIdeals()',
    '[attr.disabled]': 'disabled() || null',
    '[attr.type]': 'type()',
    class: 'ideals-icon-button',
    '[class.ideals-icon-button--primary]': 'severity() === "primary"',
    '[class.ideals-icon-button--secondary]': 'severity() === "secondary"',
    '[class.ideals-icon-button--warning]': 'severity() === "warning"',
    '[class.ideals-icon-button--danger]': 'severity() === "danger"',
    '[class.ideals-icon-button--sm]': 'size() === "small"',
    '[class.ideals-icon-button--md]': 'size() === "medium"',
    '[class.ideals-icon-button--lg]': 'size() === "large"',
  },
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'button[idealsIconButton]',
  styleUrl: './icon-button.component.scss',
  template: '<i [class]="icon()" [class.icon-marked]="iconMarked()"></i>',
})
export class IconButtonComponent {
  readonly dataIdeals = input.required<string>({ alias: 'data-ideals' });
  readonly disabled = input(false);
  readonly icon = input.required<string>({ alias: 'idealsIconButton' });
  readonly iconMarked = input(false);
  readonly severity = input<'primary' | 'secondary' | 'warning' | 'danger'>('secondary');
  readonly size = input<'small' | 'medium' | 'large'>('medium');
  readonly type = input<'button' | 'submit'>('button');

  readonly element = inject<ElementRef<HTMLInputElement>>(ElementRef).nativeElement;
}
